import { ReactComponent as Standard } from "assets/icons/standart-icon.svg";
import { ReactComponent as Bus } from "assets/icons/bus-icon.svg";
import { ReactComponent as Business } from "assets/icons/business-icon.svg";
import { ReactComponent as Universal } from "assets/icons/universal-icon.svg";
import { Tariff } from "./types";

export const DEFAULT_TARIFFS: Tariff[] = [
  {
    name: "Базовый",
    icon: Standard,
  },
  {
    name: "Универсал",
    icon: Universal,
  },
  {
    name: "Бизнес-класс",
    icon: Business,
  },
  {
    name: "Премиум-класс",
    icon: Business,
  },
  {
    name: "Эконом-класс",
    icon: Standard,
  },
  {
    name: "Микроавтобус",
    icon: Bus,
  },
];

export const mapTariffsWithIcons = (tariffs: { name: string }[]): Tariff[] => {
  return tariffs.map((tariff) => {
    const matchingTariff = DEFAULT_TARIFFS.find(
      (defaultTariff) => defaultTariff.name === tariff.name,
    );

    return {
      name: tariff.name,
      icon: matchingTariff ? matchingTariff.icon : Standard,
    };
  });
};
